

<template>
	<nav class="nav-mobile p-6 pl-md-7 pr-md-7 pr-md-10 pt-md-7 pb-30 pb-md-20" :class="{'has-back':current.parent}">
		
		<template v-if="hotspots && hotspots.length" v-for="(hotspot, index) in hotspots">
			<a @click="onClick(hotspot)" class="d-flex pr-5 align-items-center">

				<figure :style="`background-image:url(${hotspot.thumb})`" class="mr-md-8 mr-5 d-flex">
					<i class="fa fa-play" v-if="hotspot.type == 4"></i>
				</figure>

				<h6>{{ hotspot.title || hotspot.article }} <span>{{ hotspot.subtitle }}</span></h6>

				<div class="p-3 ml-auto icon-box align-items-center justify-content-center d-none d-md-flex" :class="`ic-${hotspot.icon}`">
					<i class="icon"></i>
				</div>

				<!-- <i class="far fa-arrow-right ml-auto"></i> -->
			</a>
		</template>

	</nav>
</template>

<script>

import { EventBus } from '@/common/eventbus.js'
import { store } from '@/store'
import { mapState } from 'vuex'

import { gsap, TweenMax, TimelineMax, Power0, Power1, Power2, Power3, Power4, Expo } from 'gsap';
import { CSSPlugin } from 'gsap/CSSPlugin'
gsap.registerPlugin(CSSPlugin);

export default {
	store,
	props: ['current', 'hotspots'],
	data: () => {
		return {
			prevMenue: [],
			prevHotspots: [],
		}
	},
	computed: {
		...mapState('globals', ['app']),
		...mapState('settings', ['presets']),
	},
	watch: {
	},
	methods: {
		onClick( hotspot ) {
			var params = {
				hotspot: hotspot,
				link: hotspot.link,
				$el: this.$el,
				originalEvent: event,
			};
			EventBus.$emit('hotspot-clicked', params );
		},
	}

}
</script>

<style scoped lang="scss">
	a {
		cursor: pointer;
		background: #fff;
		margin: 0 0 2px 0;
		transition: 0.2s all;
		&:hover {
			color: #006b9e;
			background: #eee;
		}
	}
	.icon-box {
		width: 40px;
		flex: 0 0 40px;
		height: 40px;
		@media ($min-device-width-md) {
			width: 45px;
			flex: 0 0 45px;
			height: 45px;
		}
	}
	.icon {
		width: 100%;
		height: 100%;
		display: block;
		&:after {
			content: '';
			width: 100%;
			height: 100%;
			background-size: cover;
			display: block;
		}
	}	
	figure {
		background: #999 none center center no-repeat;
		background-size: cover;
		width: 80px;
		flex: 0 0 80px;
		padding-top: 18%;
		@media ($min-device-width-md) {
			padding-top: 12%;
			width: 120px;
			flex: 0 0 120px;
		}
		position: relative;
		i {
			font-size: 1rem;
			&, &:after {
				@include position( absolute, 50% auto auto 50%, 10 );
				transform: translate(-52%, -50%);
			}
			color: #000;
			text-shadow: 0 0 2px rgba(#000, 0.2);
			&:after {
				content: '';
				width: 25px;
				height: 25px;
				background: rgba(#fff, 0.8);
				border-radius: 100%;
				z-index: -1;
			}
		}
	}
	h6 {
		font-weight: 600;
		font-size: 1.4rem;
		margin: 0;
		span {
			color: #999
		}
		@media ($min-device-width-md) {
			font-size: 1.5rem;
		}
	}
</style>
